import { useNavigate } from "react-router";

export const useNavigateBack = () => {
    const navigate = useNavigate();

    return () => {
        navigate(-1);
    };
};